import { Outlet } from "react-router-dom"
import NavBar from "@/components/shared/NavBar"
import Footer from "@/components/shared/Footer"
import PromotionBanner from "@/components/shared/PromotionBanner"

export default function PublicLayout(): React.JSX.Element {
	return (
		<div className="flex min-h-screen flex-col">
			<NavBar />
			<PromotionBanner />
			<main className="flex-1">
				<Outlet />
			</main>
			<Footer />
		</div>
	)
}
